import { IAssortmentGroup } from '../../../features/assortment/models/data/IAssortmentGroup'

// this ackward mapper was created to avoid uneccessary fields like Created, CreatedBy, Modified, ModifiedBy
export const mapAssortmentGroup = (apiGroup: IAssortmentGroup): IAssortmentGroup => {
  return {
    PartnerId: apiGroup.PartnerId,
    BusinessPercentage: apiGroup.BusinessPercentage,
    EntryId: apiGroup.EntryId,
    FYear: apiGroup.FYear,
    Category: apiGroup.Category,
    GroupName: apiGroup.GroupName,
    ProgramType: apiGroup.ProgramType,
    UnitsCount: apiGroup.UnitsCount,
    SortOrder: apiGroup.SortOrder,
  }
}
